/**
 * @desc 查询竞拍详情
 */
import { AuctionDetail } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAuctionDetailParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/member/auction/detail'

export const queryAuctionDetailApi = (
  params?: QueryAuctionDetailParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuctionDetail>({
    method,
    url,
    params,
    ...config
  })
}

queryAuctionDetailApi.method = method
queryAuctionDetailApi.url = url
